
varying vec3 vColor;
uniform vec2 uResolution;
uniform float uSize;
uniform sampler2D uParticlesTexture;
attribute vec2 aParticlesUv;
attribute vec3 aColor;
attribute float aSize;

// This will find the position of the particle in the world space and map its texture and final position 
void main() {
    vec4 particle = texture(uParticlesTexture, aParticlesUv);

    vec4 modelPosition = modelMatrix * vec4(particle.xyz, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    float sizeIn = smoothstep(0.0, 0.1, particle.w);
    float sizeOut = 1.0 - smoothstep(0.7, 1.0, particle.w);
    float size = min(sizeIn, sizeOut);
 
    gl_PointSize = size * aSize * uSize * uResolution.y;
    gl_PointSize *= (1.0 / -viewPosition.z);

    vColor = aColor;
}